import React from 'react';
import NumberFormat from 'react-number-format';


export default class Tabela extends React.Component {

constructor() {
  super();    
  this.state = {
    headersParams: [],
  };
}

// componentDidMount() {
//   this.setState({ showData: this.state.showData.concat(this.props.body.slice(0, 5000)), zaladowano: 5000});
// }

// loadMoreData = () => {
//   let zaladowano = this.state.zaladowano;
//   let zaladujDo = zaladowano + 2500;
//   setTimeout(() => {
//     this.setState({
//       showData: this.state.showData.concat(this.props.body.slice(zaladowano, zaladujDo)),
//       zaladowano: zaladujDo
//     });
//     alert('kolejne')
//   }, 2000);
// };

componentDidMount() {
  this.props.headers.map((data, idx) => {
    this.addToHeaders(data.typ)
  });
}

addToHeaders = (value) => {
  this.setState(prevState => ({
    headersParams: [...prevState.headersParams, value]
  }));
}

parsedDate = (strDate) => {
  if(strDate !== null) {
    var strSplitDate = String(strDate).split(' ');
    var date = new Date(strSplitDate[0]);
    var dd = date.getDate();
    var mm = date.getMonth() + 1; 
    var yyyy = date.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    date =  dd + "/" + mm + "/" + yyyy;
    return date.toString();
  } else {
    return null
  }
}

render() {

return (
<React.Fragment>
<div className="d-flex flex-column">
{this.props.header ? (this.props.header.map(items => <b>{items}</b>)) : null }
{this.props.headerExt ? (this.props.headerExt.map(items => <p>{items}</p>)) : null }
<table className="table table-striped mt-2 mb-2">
<thead>
  <tr key="01">
    {this.props.headers.map((data, idx) => {
      return <th key={idx}>{data.name}</th>
    })}
  </tr>
</thead>
<tbody>
  {this.props.body.map((data, idx) => {
    return (<><tr key={idx} id={idx}>
      {data.map((ins, idx) => {
        return <td key={idx} style={this.state.headersParams[idx] == 'varchar' || this.state.headersParams[idx] == 'integer' ? { textAlign: 'left'} : { textAlign: 'right'} }>
          {this.state.headersParams[idx] == 'varchar' || this.state.headersParams[idx] == 'integer' ? ins : (<>{this.state.headersParams[idx] == 'datetime' || this.state.headersParams[idx] == 'timestamp' ? (this.parsedDate(ins)) : (<NumberFormat value={ins} thousandSeparator={' '} style={{ whiteSpace: 'nowrap' }} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />)}</>)}
        </td>
      })}
    </tr></>)
  })}
</tbody>
</table>
{this.props.footer ? (this.props.footer.map(items => <p>{items}</p>)) : null }
</div>
</React.Fragment>
)


}
}
